import { render, staticRenderFns } from "./TravelPolicy.vue?vue&type=template&id=f6a8113c&"
import script from "./TravelPolicy.vue?vue&type=script&lang=js&"
export * from "./TravelPolicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports